/**
 * Properties of a Recipe's Portions.
 */

import { number, object, string, type InferType } from "yup"
import { RecipeSchemaNameMaxLength } from "./constants"

// Schema for portion objects within the Recipe.portions array
export const RecipePortionSchema = object({
  id: string().optional(),
  order: number().integer().min(0).required("Reihenfolge ist erforderlich"),
  name: string()
    .required("Portionsname ist erforderlich")
    .max(RecipeSchemaNameMaxLength),
  percentage: number()
    .required("Prozentsatz ist erforderlich")
    .positive("Prozentsatz muss größer 0 sein"),
})

export const RecipePortionForDeviceSchema = RecipePortionSchema.omit([
  "id",
]).concat(
  object({
    id: string().required("Portion ID ist erforderlich"),
  })
)

export type RecipePortionDto = InferType<typeof RecipePortionSchema>

// type Prettify<T> = {
//   [K in keyof T]: T[K];
// } & {};
// type asdf = Prettify<RecipePortionSchema>
// type asdf2 = Prettify<RecipePortionDto>
